import http from "@/utils/http";

export function adminLogin(payload) {
  return http.post("/auth/admin_login", payload);
}

export function adminChangePassword(payload) {
  return http.post("/auth/admin_change_password", payload);
}

export function wxLogin(code) {
  return http.post("/auth/wx_login", { code });
}

export function getMe() {
  return http.get("/user/me");
}

export function getUsers(params) {
  return http.get("/user/index", { params });
}

export function getOrgs() {
  return http.get("/org/index");
}

export function searchOrgs(params) {
  return http.get("/org/index", { params });
}

export function createOrg(name) {
  return http.post("/org/create", { name });
}

export function deleteOrg(id) {
  return http.post("/org/delete", { id });
}

export function getCabinets(params) {
  return http.get("/cabinet/index", { params: params || {} });
}

export function getCabinetDetail(id) {
  return http.get("/cabinet/show", { params: { id } });
}

export function createCabinet(payload) {
  return http.post("/cabinet/create", payload);
}

export function updateCabinet(payload) {
  return http.post("/cabinet/update", payload);
}

export function deleteCabinet(id) {
  return http.post("/cabinet/delete", { id });
}

export function remoteOpenCabinet(cabinetId) {
  return http.post("/cabinet/open", { cabinetId, source: "platform" });
}

export function getCabinetTree() {
  return http.get("/cabinet/tree");
}

export function getUserCabinetIds(userId) {
  return http.get("/cabinet/assigned", { params: { userId } });
}

export function saveUserCabinets(payload) {
  return http.post("/cabinet/assign_many", payload);
}

export function getRoles() {
  return http.get("/role/index");
}

export function createRole(payload) {
  return http.post("/role/create", payload);
}

export function assignRole(payload) {
  return http.post("/role/assign", payload);
}

export function getLogs(params) {
  return http.get("/log/index", { params });
}

export function getOpenLogs(params) {
  return http.get("/log/open_logs", { params });
}

